import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { Loader, Empty } from "@/components/common";
import { RichHtml } from "@/components/RichText";

export function BlogList() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);
  if (!posts) return <Loader />;
  return (
    <div className="w-container py-10">
      <h1 className="text-4xl font-extrabold mb-2" data-testid="blog-list-title">Washly Journal</h1>
      <p className="w-muted mb-8">Tipps rund um Wäsche, Nachbarschaft und ein bisschen mehr freie Zeit.</p>
      {posts.length === 0 ? <Empty>Noch keine Beiträge – bald geht's los.</Empty> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} className="w-card w-hover-lift overflow-hidden flex flex-col" data-testid={`blog-card-${p.slug}`}>
              {p.image_url && <img src={p.image_url} alt="" className="h-44 w-full object-cover" />}
              <div className="p-5 flex-1 flex flex-col">
                <h2 className="text-xl font-bold mb-1">{p.title}</h2>
                <p className="w-muted text-sm mb-3">{p.excerpt}</p>
                <span className="w-muted text-xs mt-auto flex items-center gap-1"><CalendarDays size={13} aria-hidden="true" /> {p.published_at ? fmtDate(p.published_at.slice(0, 10)) : ""}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setErr(true)); }, [slug]);
  if (err) return <div className="w-container py-10"><Empty>Beitrag nicht gefunden.</Empty></div>;
  if (!p) return <Loader />;
  return (
    <article className="w-container py-10 max-w-3xl">
      <Link to="/blog" className="w-muted inline-flex items-center gap-1 mb-6 hover:underline"><ArrowLeft size={16} aria-hidden="true" /> Alle Beiträge</Link>
      <h1 className="text-4xl font-extrabold mb-3" data-testid="blog-post-title">{p.title}</h1>
      <p className="w-muted mb-6 flex items-center gap-1"><CalendarDays size={14} aria-hidden="true" /> {p.published_at ? fmtDate(p.published_at.slice(0, 10)) : ""} · {p.author}</p>
      {p.image_url && <img src={p.image_url} alt="" className="rounded-2xl w-full aspect-[16/9] object-cover mb-8" />}
      <div className="max-w-none text-lg" data-testid="blog-post-body">
        <RichHtml html={p.body} />
      </div>
    </article>
  );
}
